// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.products-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .products-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .products-page {
    padding: 16px 16px 28px;
  }
}

.products-header {
  margin-bottom: 28px;
}
.products-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.products-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 640px) {
  .products-header__title {
    font-size: 22px;
  }
}
.products-header__count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(0, 173, 208), #008ba7);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.products-header__count-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.products-header__cart {
  margin-left: auto;
}
.products-header__cart-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: #676a6c;
  font-size: 18px;
  transition: all 0.15s ease;
  text-decoration: none;
}
.products-header__cart-link:hover {
  background: #f1f1f2;
  color: rgb(0, 173, 208);
}
.products-header__cart-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.products-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
}
.products-breadcrumb li {
  display: flex;
  align-items: center;
}
.products-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
}
.products-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.products-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.products-breadcrumb li.products-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.products-toolbar {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .products-toolbar {
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
  }
}
.products-toolbar__filter {
  flex: 1;
}
.products-toolbar__filter label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.products-toolbar__filter--search {
  flex: 2;
}
.products-toolbar__search-wrap {
  position: relative;
}
.products-toolbar__input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.products-toolbar__input::placeholder {
  color: #ccc;
}
.products-toolbar__input:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.products-toolbar select.products-toolbar__input {
  appearance: auto;
  cursor: pointer;
}
.products-toolbar__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  color: #ccc;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.15s ease;
}
.products-toolbar__clear:hover {
  color: rgb(245, 67, 89);
  background: rgba(245, 67, 89, 0.06);
}

.products-content {
  min-height: 200px;
}

.products-category {
  margin-bottom: 40px;
}
.products-category[hidden] {
  display: none !important;
}
.products-category__title {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e7eaec;
}
.products-category__title:empty {
  display: none;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}
@media (max-width: 640px) {
  .products-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.products-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.products-card[hidden] {
  display: none !important;
}
.products-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}
.products-card__image-link {
  display: block;
  text-decoration: none;
  overflow: hidden;
}
.products-card__image {
  width: 100%;
  aspect-ratio: 4/5;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}
.products-card__image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.35s ease;
}
.products-card__image:hover img {
  transform: scale(1.04);
}
.products-card__body {
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.products-card__name {
  margin-bottom: 4px;
}
.products-card__name-link {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #6d6e71;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
  transition: color 0.2s;
}
.products-card__name-link:hover {
  color: rgb(105, 190, 40);
}
.products-card__price {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: rgb(105, 190, 40);
  display: block;
  margin-bottom: 10px;
}
.products-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
}
.products-card__qty {
  flex-shrink: 0;
}
.products-card__qty-input {
  width: 56px;
  height: 32px;
  border: 1px solid #e7eaec;
  border-radius: 5px;
  padding: 2px 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  text-align: center;
  color: #6d6e71;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}
.products-card__qty-input::-webkit-inner-spin-button, .products-card__qty-input::-webkit-outer-spin-button {
  opacity: 1;
  height: 24px;
}
.products-card__qty-input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.12);
}
.products-card__btn-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.products-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  line-height: 1.4;
  border: 1.5px solid transparent;
}
.products-btn--filled-green {
  background-color: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.products-btn--filled-green:hover {
  background-color: #569c21;
  border-color: #569c21;
  color: #fff;
  text-decoration: none;
}
.products-btn--outline-green {
  background: transparent;
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.products-btn--outline-green:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
  text-decoration: none;
}
.products-btn--outline-cyan {
  background: transparent;
  color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
}
.products-btn--outline-cyan:hover {
  background-color: rgb(0, 173, 208);
  color: #fff;
  text-decoration: none;
}

.products-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.products-empty > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.products-empty p {
  font-size: 15px;
  color: #676a6c;
  margin: 0;
}
.products-empty__reset {
  margin-top: 12px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: rgb(0, 173, 208);
  background: #fff;
  border: 1px solid rgb(0, 173, 208);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.products-empty__reset:hover {
  background: rgba(0, 173, 208, 0.06);
}

.products-loader {
  width: 100%;
  padding: 60px 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/store-products/store-products.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAzYA;EACE,uBAAA;EACA,iBAAA;AA4YF;AA1YE;EAJF;IAI8B,uBAAA;EA8Y5B;AACF;AA9YE;EALF;IAK8B,uBAAA;EAkZ5B;AACF;;AA5YA;EACE,mBAAA;AA+YF;AA7YE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA+YJ;AA5YE;EACE,eAAA;EACA,gBAAA;EACA,cDWiB;ECVjB,SAAA;EACA,uBAAA;EACA,wEDhCS;AC8ab;AA5YI;EARF;IAQ8B,eAAA;EAgZ9B;AACF;AA9YE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDhDS;ACgcb;AA9YI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AAgZN;AA5YE;EACE,iBAAA;AA8YJ;AA3YE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cDpCiB;ECqCjB,eAAA;EACA,0BAAA;EACA,qBAAA;AA6YJ;AA3YI;EACE,mBDlCgB;ECmChB,uBDzDU;ACschB;AAzYE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,6BDtEY;ECuEZ,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA2YJ;;AAnYA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AAsYF;AApYE;EACE,aAAA;EACA,mBAAA;AAsYJ;AApYI;EACE,YAAA;EACA,aAAA;EACA,WD9Ec;ACodpB;AAnYI;EACE,cDzFe;EC0Ff,qBAAA;EACA,4BAAA;AAqYN;AAnYM;EAAU,uBD3GA;ACifhB;AAnYI;EACE,cD5Fe;EC6Ff,gBAAA;AAqYN;;AA5XA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBDxGoB;ECyGpB,kBAAA;EACA,yBAAA;AA+XF;AA7XE;EATF;IAUI,sBAAA;IACA,SAAA;IACA,kBAAA;EAgYF;AACF;AA9XE;EACE,OAAA;AAgYJ;AA9XI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD9He;EC+Hf,kBAAA;AAgYN;AA7XI;EACE,OAAA;AA+XN;AA3XE;EACE,kBAAA;AA6XJ;AA1XE;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEDzLS;EC0LT,cDvJiB;ECwJjB,gBAAA;EACA,aAAA;EACA,wDAAA;AA4XJ;AA1XI;EAAiB,WDrJD;ACkhBpB;AA3XI;EACE,8BD7KU;EC8KV,4CAAA;AA6XN;AAzXE;EACE,gBAAA;EACA,eAAA;AA2XJ;AAxXE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,WD9KgB;EC+KhB,eAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AA0XJ;AAxXI;EACE,uBDvMY;ECwMZ,mCAAA;AA0XN;;AAjXA;EACE,iBAAA;AAoXF;;AA7WA;EACE,mBAAA;AAgXF;AA9WE;EAAY,wBAAA;AAiXd;AA/WE;EACE,wEDvPS;ECwPT,eAAA;EACA,gBAAA;EACA,cDlNiB;ECmNjB,gBAAA;EACA,oBAAA;EACA,gCAAA;AAiXJ;AA/WI;EACE,aAAA;AAiXN;;AAxWA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA2WF;AAzWE;EALF;IAMI,0BAAA;IACA,SAAA;EA4WF;AACF;;AArWA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAGA,uDAAA;AAsWF;AAvWE;EAAY,wBAAA;AA0Wd;AAvWE;EACE,0CAAA;EACA,2BAAA;AAyWJ;AArWE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAuWJ;AApWE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAsWJ;AApWI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AAsWN;AAnWI;EACE,sBAAA;AAqWN;AAhWE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AAkWJ;AA9VE;EACE,kBAAA;AAgWJ;AA7VE;EACE,wEDnVS;ECoVT,eAAA;EACA,gBAAA;EACA,cD9SiB;EC+SjB,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;AA+VJ;AA7VI;EACE,wBD1UU;ACyqBhB;AA1VE;EACE,wEDvWS;ECwWT,eAAA;EACA,gBAAA;EACA,wBDnVY;ECoVZ,cAAA;EACA,mBAAA;AA4VJ;AAxVE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA0VJ;AAtVE;EACE,cAAA;AAwVJ;AArVE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wEDlYS;ECmYT,eAAA;EACA,kBAAA;EACA,cD7ViB;EC8VjB,gBAAA;EACA,aAAA;EACA,6BAAA;AAuVJ;AArVI;EAEE,UAAA;EACA,YAAA;AAsVN;AAnVI;EACE,+BD1XU;EC2XV,8CAAA;AAqVN;AAhVE;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAkVJ;;AA1UA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wEDvaW;ECwaX,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;AA6UF;AA3UE;EACE,mCD5ZY;EC6ZZ,WAAA;EACA,+BD9ZY;AC2uBhB;AA3UI;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AA6UN;AAzUE;EACE,uBAAA;EACA,wBD1aY;EC2aZ,+BD3aY;ACsvBhB;AAzUI;EACE,mCD9aU;EC+aV,WAAA;EACA,qBAAA;AA2UN;AAvUE;EACE,uBAAA;EACA,uBDxbY;ECybZ,8BDzbY;ACkwBhB;AAvUI;EACE,kCD5bU;EC6bV,WAAA;EACA,qBAAA;AAyUN;;AAhUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAmUF;AAjUE;EACE,eAAA;EACA,mBAAA;EACA,WD7bgB;ACgwBpB;AAhUE;EACE,eAAA;EACA,cDzciB;EC0cjB,SAAA;AAkUJ;AA/TE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDrfS;ECsfT,uBDjeY;ECkeZ,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAiUJ;AA/TI;EACE,mCAAA;AAiUN;;AAxTA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AA2TF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n// ─────────────────────────────────────────────\n// Page Layout\n// ─────────────────────────────────────────────\n\n.products-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// ─────────────────────────────────────────────\n// Header\n// ─────────────────────────────────────────────\n\n.products-header {\n  margin-bottom: 28px;\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n\n  &__count {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    height: 28px;\n    padding: 0 12px;\n    border-radius: 14px;\n    background: linear-gradient(135deg, $clarify-color, darken($clarify-color, 8%));\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: $font-stack;\n\n    &-label {\n      font-size: 11px;\n      font-weight: 500;\n      opacity: 0.85;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n\n  &__cart {\n    margin-left: auto;\n  }\n\n  &__cart-link {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    color: $body-content-color;\n    font-size: 18px;\n    transition: all 0.15s ease;\n    text-decoration: none;\n\n    &:hover {\n      background: $color-neutral-light;\n      color: $clarify-color;\n    }\n  }\n\n  &__cart-badge {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 5px;\n    border-radius: 9px;\n    background: $develop-color;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Breadcrumb\n// ─────────────────────────────────────────────\n\n.products-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after {\n      content: '/';\n      margin: 0 8px;\n      color: $color-neutral-mid;\n    }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n\n      &:hover { color: $clarify-color; }\n    }\n\n    &.products-breadcrumb__current {\n      color: $color-neutral-dark;\n      font-weight: 600;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Toolbar / Filters\n// ─────────────────────────────────────────────\n\n.products-toolbar {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 16px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n\n  &__filter {\n    flex: 1;\n\n    label {\n      display: block;\n      font-size: 11px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      color: $color-neutral-dark;\n      margin-bottom: 6px;\n    }\n\n    &--search {\n      flex: 2;\n    }\n  }\n\n  &__search-wrap {\n    position: relative;\n  }\n\n  &__input {\n    width: 100%;\n    padding: 9px 12px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: #fff;\n    outline: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n    &::placeholder { color: $color-neutral-mid; }\n\n    &:focus {\n      border-color: $clarify-color;\n      box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n    }\n  }\n\n  select.products-toolbar__input {\n    appearance: auto;\n    cursor: pointer;\n  }\n\n  &__clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border: none;\n    background: none;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    font-size: 14px;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n\n    &:hover {\n      color: $implement-color;\n      background: rgba($implement-color, 0.06);\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Content Area\n// ─────────────────────────────────────────────\n\n.products-content {\n  min-height: 200px;\n}\n\n// ─────────────────────────────────────────────\n// Category Sections\n// ─────────────────────────────────────────────\n\n.products-category {\n  margin-bottom: 40px;\n\n  &[hidden] { display: none !important; }\n\n  &__title {\n    font-family: $font-stack;\n    font-size: 24px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0 0 20px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid $color-grey-1;\n\n    &:empty {\n      display: none;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Product Grid\n// ─────────────────────────────────────────────\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Product Card\n// ─────────────────────────────────────────────\n\n.products-card {\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  &[hidden] { display: none !important; }\n  transition: box-shadow 0.25s ease, transform 0.25s ease;\n\n  &:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n    transform: translateY(-3px);\n  }\n\n  // Image area\n  &__image-link {\n    display: block;\n    text-decoration: none;\n    overflow: hidden;\n  }\n\n  &__image {\n    width: 100%;\n    aspect-ratio: 4 / 5;\n    overflow: hidden;\n    background: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n      object-fit: contain;\n      transition: transform 0.35s ease;\n    }\n\n    &:hover img {\n      transform: scale(1.04);\n    }\n  }\n\n  // Card body\n  &__body {\n    padding: 14px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n\n  // Product name\n  &__name {\n    margin-bottom: 4px;\n  }\n\n  &__name-link {\n    font-family: $font-stack;\n    font-size: 14px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n    text-decoration: none;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.35;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $develop-color;\n    }\n  }\n\n  // Price\n  &__price {\n    font-family: $font-stack;\n    font-size: 16px;\n    font-weight: 700;\n    color: $develop-color;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  // Actions area\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: auto;\n  }\n\n  // Quantity input\n  &__qty {\n    flex-shrink: 0;\n  }\n\n  &__qty-input {\n    width: 56px;\n    height: 32px;\n    border: 1px solid $color-grey-1;\n    border-radius: 5px;\n    padding: 2px 4px;\n    font-family: $font-stack;\n    font-size: 13px;\n    text-align: center;\n    color: $color-neutral-dark;\n    background: #fff;\n    outline: none;\n    transition: border-color 0.2s;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      opacity: 1;\n      height: 24px;\n    }\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.12);\n    }\n  }\n\n  // Button group\n  &__btn-group {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Buttons\n// ─────────────────────────────────────────────\n\n.products-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 12px;\n  font-family: $font-stack;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  line-height: 1.4;\n  border: 1.5px solid transparent;\n\n  &--filled-green {\n    background-color: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n\n    &:hover {\n      background-color: darken(rgba(105, 190, 40, 1), 8%);\n      border-color: darken(rgba(105, 190, 40, 1), 8%);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-green {\n    background: transparent;\n    color: $develop-color;\n    border-color: $develop-color;\n\n    &:hover {\n      background-color: $develop-color;\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-cyan {\n    background: transparent;\n    color: $clarify-color;\n    border-color: $clarify-color;\n\n    &:hover {\n      background-color: $clarify-color;\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Empty State\n// ─────────────────────────────────────────────\n\n.products-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i {\n    font-size: 36px;\n    margin-bottom: 16px;\n    color: $color-neutral-mid;\n  }\n\n  p {\n    font-size: 15px;\n    color: $body-content-color;\n    margin: 0;\n  }\n\n  &__reset {\n    margin-top: 12px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    color: $clarify-color;\n    background: #fff;\n    border: 1px solid $clarify-color;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background: rgba($clarify-color, 0.06);\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Loading State\n// ─────────────────────────────────────────────\n\n.products-loader {\n  width: 100%;\n  padding: 60px 0;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
